import { Injectable } from '@angular/core'
import { SegmentService } from '../../shared/analytics/services/segment.service'
import { SegmentTagV2 } from '../../shared/analytics/models/segment-tag.model'
import { SegmentEvents } from '../../shared/analytics/models/segment-events.model'

/**
 * The standard Page tag for the Watch On Web page.
 *
 * @remarks
 * This is expected to be used with pageV2, as indicated by the use of the
 * SegmentTagV2 interface and `autoPageCall: false`.
 *
 * @see SegmentService#pageV2
 * @see SegmentTagV2
 */
export const WATCH_ANALYTICS_TAG: SegmentTagV2 = {
  page_category: 'Watch',
  category: 'Watch',
  autoPageCall: false
}

/**
 * Handler for all watch-related analytics activities like page/track calls.
 *
 * @see SegmentService
 * @see SegmentTagV2
 */
@Injectable()
export class WatchAnalyticsService {
  constructor(private readonly segmentService: SegmentService) {}

  /**
   * Send a page call for the Watch On Web landing page.
   */
  public sendPageCall(): void {
    return this.segmentService.pageV2(WATCH_ANALYTICS_TAG, { _tag: 'list' })
  }

  /**
   * Send a Preview Stream Displayed event when user sees a live preview stream.
   */
  public sendPreviewStreamDisplayed(liveEventId: number) {
    return this.segmentService.trackPreviewStreamDisplayed(SegmentEvents.STREAM_PREVIEW_DISPLAYED, {
      live_id: liveEventId
    })
  }

  /**
   * Send scrolling page number for when the user loads a new section on watch on web
   */
  public sendScrollingPage(page: number) {
    this.segmentService.trackEvent({
      name: SegmentEvents.INFINITE_SCROLL,
      properties: { page }
    })
  }
}
